import type { OpportunityStatusOldType } from '@/api/opportunity';
import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import { usePageFilterContext } from '@/components/page';
import { OpportunityAttributionOfflineTable } from '@/features/OpportunityAttributionOfflineTable';
import { OpportunityAttributionOnlineTable } from '@/features/OpportunityAttributionOnlineTable';

const ONLINE_DEFAULT_SORT = {
  sortBy: 'audienceVisits',
  sortOrder: InstantSearchSortOrder.DESC,
};

const ONLINE_DEFAULT_FILTERS = [
  {
    field: 'audienceVisits',
    min: {
      inclusive: true,
      operand: '1',
    },
  },
];

const OFFLINE_DEFAULT_SORT = {
  sortBy: 'audienceOfflineEvents',
  sortOrder: InstantSearchSortOrder.DESC,
};

const OFFLINE_DEFAULT_FILTERS = [
  {
    field: 'audienceOfflineEvents',
    min: {
      inclusive: true,
      operand: '1',
    },
  },
];

const ONLINE_DEFAULT_QUERY_STATE: Partial<QueryState> = {
  ...ONLINE_DEFAULT_SORT,
  size: 10,
  filters: ONLINE_DEFAULT_FILTERS,
};

const OFFLINE_DEFAULT_QUERY_STATE: Partial<QueryState> = {
  ...OFFLINE_DEFAULT_SORT,
  size: 10,
  filters: OFFLINE_DEFAULT_FILTERS,
};

type Props = {
  oppType: OpportunityStatusOldType;
};

const AttributionBreakdownTables = ({ oppType }: Props) => {
  const {
    pageFilters: { startDate, endDate },
  } = usePageFilterContext();

  return (
    <>
      <InstantSearch defaultQueryState={ONLINE_DEFAULT_QUERY_STATE} urlSync={false}>
        <OpportunityAttributionOnlineTable
          oppType={oppType}
          defaultSort={ONLINE_DEFAULT_SORT}
          defaultFilters={ONLINE_DEFAULT_FILTERS}
          startDate={startDate}
          endDate={endDate}
        />
      </InstantSearch>
      <InstantSearch defaultQueryState={OFFLINE_DEFAULT_QUERY_STATE} urlSync={false}>
        <OpportunityAttributionOfflineTable
          oppType={oppType}
          defaultSort={OFFLINE_DEFAULT_SORT}
          defaultFilters={OFFLINE_DEFAULT_FILTERS}
          startDate={startDate}
          endDate={endDate}
        />
      </InstantSearch>
    </>
  );
};

export default AttributionBreakdownTables;
